import React from 'react';
import { TextField, Typography, InputAdornment } from '@mui/material';
import { StyledCommonInput } from './index.style';

const CommonInput = ({
  label,
  name,
  value = '',
  placeholder = '',
  onChange,
  error = false,
  helperText = '',
  disabled = false,
  startAdornment,
  endAdornment,
  type = 'text',
  ...props
}) => (
  <StyledCommonInput>
    <Typography className="input-label">{label}</Typography>
    <TextField
      name={name}
      type="text"
      value={value}
      placeholder={placeholder}
      disabled={disabled}
      size="small"
      className="input-field"
      fullWidth
      onChange={onChange}
      error={error}
      InputProps={{
        startAdornment: startAdornment ? (
          <InputAdornment position="start">{startAdornment}</InputAdornment>
        ) : null,
        endAdornment: endAdornment ? (
          <InputAdornment position="end">{endAdornment}</InputAdornment>
        ) : null,
        type,
      }}
      {...props}
      sx={{
        '& .MuiFormHelperText-root': {
          marginLeft: 0,
          marginTop: '4px',
        },
        ...props?.sx,
      }}
    />
    {error && <Typography className="input-error">{helperText}</Typography>}
  </StyledCommonInput>
);

export default CommonInput;
